import React, { Component } from 'react';

class ReferLoading extends Component {
    constructor (props) {
        super(props);
        this.state = { progress: 0 };
        this.progress = 0;
    }

    componentDidMount() {
        if (this.props.show) {
            this.setProgress();
        }
    }

    //WARNING! To be deprecated in React v17. Use new lifecycle static getDerivedStateFromProps instead.
    componentWillReceiveProps(nextProps) {
        if (!this.props.show && nextProps.show) {
            // 开始
            this.setProgress();
        }
    }

    setProgress = () => {
        let progress = 0;

        this.progressBar && (this.progressBar.style.display = 'inline-block');

        let loading = () => {
            if (progress >= 100) {
                this.progressBar && (this.progressBar.style.display = 'none');
                return;
            }

            if (this.props.show) {
                if (progress <= 70) {
                    progress += 6;
                } else if (progress <= 90) {
                    progress += 0.1;
                    
                }
            } else {
                progress += 10;
                
            }
            this.progressBar && (this.progressBar.style.width = Math.min(progress, 100) + '%');

            requestAnimationFrame(loading);
        }

        requestAnimationFrame(loading);
    }

    render () {
        return <div className="refer-loading">
            <div className="refer-loading-progress" ref={dom => {
                this.progressBar = dom;
            }}></div>
        </div>;
    }
}

export default ReferLoading;